import type { Chart, ChartData, ChartOptions, Plugin } from 'chart.js';
import { type MutableRefObject, type ReactNode, type RefObject, useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';

import { DEFAULT_PIE_CHART_OPTIONS } from '../lib/default-chart-options';
import { mergeChartConfig } from '../lib/merge-chart-config';

export type PieChartProps = {
  chartRef?: RefObject<Chart<'doughnut'>>;
  data: ChartData<'doughnut'>;
  options?: ChartOptions<'doughnut'>;
  plugins?: Plugin<'doughnut'>[];
  children?: ReactNode;
};

export const PieChart = ({
  chartRef,
  data,
  options,
  plugins,
  children,
}: PieChartProps) => {
  const mergedOptions = useMemo(
    () => mergeChartConfig(DEFAULT_PIE_CHART_OPTIONS, options),
    [options],
  );

  return (
    <>
      <Doughnut
        ref={
          chartRef as MutableRefObject<Chart<'doughnut'> | undefined | null>
        }
        data={data}
        options={mergedOptions}
        plugins={plugins ?? []}
      />
      {children}
    </>
  );
};
